import { SETTINGS_UNIQUE_ENTRY_ID } from './init';

export const SettingssList = (_props: unknown) => {
  window.location.href = `#/settings/${SETTINGS_UNIQUE_ENTRY_ID}`;
  return null;
};
